import { useTranslation } from 'react-i18next';
import { Modal } from '@/shared/ui/primitives';
import { ExclamationCircleOutlined } from '@/shared/ui/icons';
import type { ReactNode } from 'react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  /** When true, the confirm button is styled as destructive. Default: true. */
  destructive?: boolean;
  okText?: string;
  cancelText?: string;
}

export default function ConfirmDialog({
  open, title, message, onConfirm, onCancel, loading,
  destructive = true, okText, cancelText,
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span
            style={{
              width: 32, height: 32, borderRadius: 'var(--r-md)',
              background: destructive ? 'var(--error-soft)' : 'var(--warning-soft)',
              color: destructive ? '#B91C1C' : '#B45309',
              display: 'grid', placeItems: 'center', flexShrink: 0,
            }}
          >
            <ExclamationCircleOutlined />
          </span>
          <span>{title}</span>
        </div>
      }
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText={okText ?? t('common.confirm')}
      cancelText={cancelText ?? t('common.cancel')}
      okButtonProps={{ danger: destructive }}
      width={440}
    >
      <div style={{ color: 'var(--text-secondary)', lineHeight: 1.55 }}>
        {typeof message === 'string' ? <p style={{ margin: 0 }}>{message}</p> : message}
      </div>
    </Modal>
  );
}
